export const mixpanel = {
  state: { nonActionableMetadata: {} },
  reducers: {
    addMetadata: (state, data) => ({ ...data, nonActionableMetadata: { ...state.nonActionableMetadata } }),
    resetState: _ => ({}),
    addNonActionableMetadata: (state, data) => ({ nonActionableMetadata: { ...state.nonActionableMetadata, ...data } }),
  },
};
